import { render, staticRenderFns } from "./HomeLeagueCard.vue?vue&type=template&id=3c5e7862&scoped=true"
import script from "./HomeLeagueCard.vue?vue&type=script&lang=ts"
export * from "./HomeLeagueCard.vue?vue&type=script&lang=ts"
import style0 from "./HomeLeagueCard.vue?vue&type=style&index=0&id=3c5e7862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e7862",
  null
  
)

export default component.exports